import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { UserInfo, Item, Tool, AddNewUserInfo, Response, Job, Role } from '../models';
import { Company } from '../models/user-info.model';

@Injectable({ providedIn: 'root' })
export class UserService {
  private user_info : UserInfo = null;

  constructor(private http: HttpClient) { }


  async checkIfUserIsMe(user: UserInfo) {
    const actualUser = await this.getUserInfo();
    if (user.id === actualUser.id) {
      return 'You';
    } else {
      return undefined;
    }
  }

    async getToolsAndPrivileges(ue: UserInfo): Promise<any> {
        return await this.http.post<any>(`${environment.apiUrl}/getToolsAndPrivileges`, ue).toPromise();
    }

    async getUserInfo(): Promise<UserInfo> {
        if(!this.user_info) this.user_info = await this.http.get<UserInfo>(`${environment.apiUrl}/HomePage-UserInfo`).toPromise();
        return this.user_info;
    }
    async getAvailableToolsAndPrivileges(): Promise<any>{
        return await this.http.get<UserInfo>(`${environment.apiUrl}/getAvailableToolsAndPrivileges`).toPromise();  
    }

  async getSessionID(): Promise<{ id_session: string }> {
    return this.http.get<{ id_session: string }>(`${environment.apiUrl}/Get-GetSession`,
    ).toPromise().then(res => {
      localStorage.setItem('SessionID', res.id_session);
      return res;
    }).catch(err => {
      console.error('err', err);
      return err;
    });
  }

  async closeSession(): Promise<{message: string}> {
    return this.http.get<{message: string}>(`${environment.apiUrl}/Get-CloseSession`).toPromise();
  }

  getRecentItems(): Promise<{ items: Item[] }> {
    return this.http.get<{ items: Item[] }>(`${environment.apiUrl}/HomePage-RecentItems`).toPromise();
  }

  getFavouriteItems(columnName?: string, orderBy?: string): Promise<{ items: Item[] }> {
    let url: string;
    if (columnName && orderBy) {
      url = `${environment.apiUrl}/HomePage-FavouriteSection?key=${columnName}&orderby=${orderBy}`;
    } else {
      url = `${environment.apiUrl}/HomePage-FavouriteSection`;
    }
    return this.http.get<{ items: Item[] }>(url).toPromise();
  }

  getUserTool(): Promise<{ tools: Tool[] }> {
    return this.http.get<{ tools: Tool[] }>(`${environment.apiUrl}/ToolBar-GetUserTool`,

    ).toPromise();
  }

    addNewUser(newUser: AddNewUserInfo): Promise<Response> {
      // console.log(newUser)
      return this.http.post<Response>(`${environment.apiUrl}/Website-AddNewUser`,
        {
          role: newUser.role,
          name: newUser.name,
          surname: newUser.surname,
          email: newUser.email,
          company: newUser.company,
          id_job_title: newUser.id_job_title,
          tool_privileges: newUser.tool_privileges,
          special_property : newUser.special_property
        }
      ).toPromise();
  }

  getUsersAvailable(emailAddress: string): Promise<{users_available: AddNewUserInfo[]}> {
    return this.http.get<{users_available: AddNewUserInfo[]}>(`${environment.apiUrl}/GetUsersAvailable`,
      {
        params: new HttpParams()
          .set('email_address', emailAddress)
      }
    ).toPromise();
  }

  /*getJobs(): Promise<{ job_titles: Job[] }> {
    return this.http.get<{ job_titles: Job[] }>(`${environment.apiUrl}/GetJobTitleAvailable`).toPromise();
  }*/

  getRoles(): Promise<{ roles: Role[] }> {
    return this.http.get<{ roles: Role[] }>(`${environment.apiUrl}/GetRoleAvailable`).toPromise();
  }

  getCompanies(): Promise<{ companies: Company[] }> {
    return this.http.get<{ companies: Company[] }>(`${environment.apiUrl}/GetAvailableCompanies`).toPromise();
  }

 addNewOrganization(companyName: string): Promise<Response> {
    return this.http.post<Response>(`${environment.apiUrl}/AddNewCompany?companyName=${companyName}`,{}).toPromise();
  }

  getSpecialPropery(ue: UserInfo): Promise<any> {
    return  this.http.post<any>(`${environment.apiUrl}/GetSpecialProperty`, ue).toPromise();
    //return new Promise((resolve, reject) => {resolve( ["property_1" , "property_2", "property_3" ])})
  }
}
